import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Select } from "#components/molecules/Select/Select";
import { ChangePartFormatConfirmationModal } from "#modules/quoteRequestLinesV2/view/organisms/ChangePartFormatConfirmationModal";
import { getSelectablePartTypeOptions } from "#shared/helpers/partTypeOptions";
import { PartTypeType } from "shared";

type Props = {
  value: PartTypeType | null;
  onConfirm: (nextType: PartTypeType) => void;
  disabled?: boolean;
  currentType?: PartTypeType | null;
};

export const PartFormatSelect = ({ value, onConfirm, disabled, currentType }: Props) => {
  const { t } = useTranslation();
  const [pendingType, setPendingType] = useState<PartTypeType | null>(null);
  const partFormatLabel = t("common.partFormat");

  const typeOptions = getSelectablePartTypeOptions(currentType).map(
    ({ value: optionValue, label }) => ({
      value: optionValue,
      label,
    }),
  );

  return (
    <>
      <Select
        value={value}
        onChange={(nextValue) => {
          const newType = nextValue as PartTypeType | null;
          if (!newType || newType === value) {
            return;
          }
          setPendingType(newType);
        }}
        data={typeOptions}
        disabled={disabled}
        placeholder={partFormatLabel}
        aria-label={partFormatLabel}
      />
      <ChangePartFormatConfirmationModal
        opened={pendingType !== null}
        onClose={() => setPendingType(null)}
        onConfirm={() => {
          if (pendingType) {
            onConfirm(pendingType);
          }
          setPendingType(null);
        }}
      />
    </>
  );
};
